(function () {
  class OiBookProduct {
    constructor(root) {
      this.root = root;
      this.mainImg = root.querySelector('[data-oi-bp-main-img]');
      this.thumbs = Array.from(root.querySelectorAll('.oi-bp-thumb'));
      this.materialBtns = Array.from(root.querySelectorAll('[data-oi-bp-material] .oi-bp-mat-btn'));
      this.materialInput = root.querySelector('[data-oi-bp-material-input]');
      this.materialLabel = root.querySelector('[data-oi-bp-material-label]');
      this.foilBtns = Array.from(root.querySelectorAll('[data-oi-bp-foil] .oi-bp-foil-btn'));
      this.foilInput = root.querySelector('[data-oi-bp-foil-input]');
      this.foilLabel = root.querySelector('[data-oi-bp-foil-label]');
      this.charCountInputs = Array.from(root.querySelectorAll('[data-oi-bp-max]'));
      this.submitBtn = root.querySelector('[data-oi-bp-submit]');
      this.bindEvents();
      this.prefillFromUrl();
    }

    bindEvents() {
      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => this.switchImage(thumb));
      });

      if (this.submitBtn) {
        this.submitBtn.addEventListener('click', () => this.goToBookSelector());
      }

      this.materialBtns.forEach((btn) => {
        btn.addEventListener('click', () => this.selectOption(btn, this.materialBtns, this.materialInput, this.materialLabel));
      });

      this.foilBtns.forEach((btn) => {
        btn.addEventListener('click', () => this.selectOption(btn, this.foilBtns, this.foilInput, this.foilLabel));
      });

      this.charCountInputs.forEach((input) => {
        const max = parseInt(input.dataset.oiBpMax, 10);
        const display = this.root.querySelector(`[data-oi-bp-charcount="${input.id}"]`);
        if (!display) return;
        const update = () => {
          display.textContent = `${input.value.length} / ${max}`;
          display.classList.toggle('is-near-limit', input.value.length > max * 0.85);
        };
        input.addEventListener('input', update);
        update();
      });
    }

    switchImage(thumb) {
      if (!this.mainImg) return;
      const src = thumb.dataset.src;
      const srcset = thumb.dataset.srcset;
      this.mainImg.src = src;
      if (srcset) this.mainImg.srcset = srcset;
      this.thumbs.forEach((t) => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
    }

    prefillFromUrl() {
      const params = new URLSearchParams(window.location.search);
      const destination = params.get('destination');
      const subtitle = params.get('subtitle');

      if (destination) {
        const destInput = this.root.querySelector('#oi-bp-destination');
        if (destInput) destInput.value = destination;
        const titleInput = this.root.querySelector('#oi-bp-title');
        if (titleInput) {
          titleInput.value = destination.toUpperCase();
          titleInput.dispatchEvent(new Event('input'));
        }
      }
      if (subtitle) {
        const subtitleInput = this.root.querySelector('#oi-bp-subtitle');
        if (subtitleInput) {
          subtitleInput.value = subtitle.toUpperCase();
          subtitleInput.dispatchEvent(new Event('input'));
        }
      }
    }

    goToBookSelector() {
      const destination = (this.root.querySelector('#oi-bp-destination')?.value || '').trim();
      const subtitle    = (this.root.querySelector('#oi-bp-subtitle')?.value || '').trim();
      const foil        = this.foilInput ? this.foilInput.value : '';
      const photo       = this.mainImg ? this.mainImg.currentSrc || this.mainImg.src : '';

      /* No add-to-cart / checkout here — the-book page's own selector handles
         configuration, pricing, and the handoff into the editor from here on. */
      const params = new URLSearchParams();
      if (destination) params.set('destination', destination);
      if (subtitle)     params.set('subtitle', subtitle);
      if (foil)         params.set('foil', foil);
      if (photo)        params.set('photo', photo);

      const query = params.toString();
      window.location.href = '/pages/the-book' + (query ? `?${query}` : '');
    }

    selectOption(btn, group, hiddenInput, labelEl) {
      group.forEach((b) => {
        b.classList.remove('is-active');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('is-active');
      btn.setAttribute('aria-pressed', 'true');
      if (hiddenInput) hiddenInput.value = btn.dataset.value;
      if (labelEl) labelEl.textContent = btn.dataset.value;
    }
  }

  function init() {
    document.querySelectorAll('[data-oi-bp-root]').forEach((root) => {
      if (root.dataset.oiBpInit) return;
      root.dataset.oiBpInit = 'true';
      new OiBookProduct(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
